import * as yup from 'yup'

export default yup.object().shape({
  agree: yup
    .boolean()
    .oneOf([true], 'Leia o Contrato antes de assinar.')
    .required('Campo requerido.')
})
